import { observable } from 'mobx';
import type { OrderItemStepStatusEnum } from './order_item_step_status';
import type { MasterOrderItemActionArgs } from '../master_step/master_order_item_action';

export interface OrderItemStepResponseArgs {
  id?: number;
  master_step_id: number;
  status: OrderItemStepStatusEnum;
  step_num: number;
  step_name?: string;
  step_code?: string;
  step_description?: string;
  step_document_url?: string;
  master_order_item_actions?: MasterOrderItemActionArgs[];
  finished_status: number;
}

export interface OrderItemStepArgs {
  id?: number;
  masterStepId: number;
  status: OrderItemStepStatusEnum;
  stepNum: number;
  stepName?: string;
  stepCode?: string;
  stepDescription?: string;
  stepDocumentUrl?: string;
  finishedStatus: number;
}

export const convertOrderItemStepResponseToArgs = (response: OrderItemStepResponseArgs) => {
  const args: OrderItemStepArgs = {
    id: response.id,
    masterStepId: response.master_step_id,
    status: response.status,
    stepNum: response.step_num,
    stepName: response.step_name,
    stepCode: response.step_code,
    stepDescription: response.step_description,
    stepDocumentUrl: response.step_document_url,
    finishedStatus: response.finished_status
  };
  return args;
};

export default class OrderItemStep {
  @observable readonly id?: number;
  @observable readonly masterStepId: number;
  @observable readonly status: OrderItemStepStatusEnum;
  @observable readonly stepNum: number;
  @observable readonly stepName?: string;
  @observable readonly stepCode?: string;
  @observable readonly stepDescription?: string;
  @observable readonly stepDocumentUrl?: string;
  @observable readonly finishedStatus: number;

  constructor(args: OrderItemStepArgs) {
    this.id = args.id;
    this.masterStepId = args.masterStepId;
    this.status = args.status;
    this.stepNum = args.stepNum;
    this.stepName = args.stepName;
    this.stepCode = args.stepCode;
    this.stepDescription = args.stepDescription;
    this.stepDocumentUrl = args.stepDocumentUrl;
    this.finishedStatus = args.finishedStatus;
  }
}
